import { jsx as _jsx } from "react/jsx-runtime";
import { datadogRum } from "@datadog/browser-rum";
import { useEffect, useState } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { ErrorBoundaryPage } from "./error-boundary-page";
function ErrorFallback(param) {
    var error = param.error;
    var ref = useState("/"), retryUrl = ref[0], setRetryUrl = ref[1];
    useEffect(function() {
        var pathname = window.location.pathname;
        setRetryUrl(pathname);
        if (process.env["STAGE_NAME"] !== "local") {
            datadogRum.addError(new Error(error.message), {
                error: {
                    message: "User shown error boundary",
                    name: error.name,
                    stack: error.stack
                },
                route: pathname
            });
        }
    }, []);
    return /*#__PURE__*/ _jsx(ErrorBoundaryPage, {
        errorTitle: "Something went wrong...",
        errorText: "We are attempting to resolve the issue but if it's taking too long you can use the buttons below to continue you journey",
        homeCtaText: "Return home",
        searchCarsCtaText: "Search cars",
        currentUrl: retryUrl
    });
}
export var ErrorBoundaryWrapper = function(param) {
    var children = param.children;
    return /*#__PURE__*/ _jsx(ErrorBoundary, {
        FallbackComponent: ErrorFallback,
        children: children
    });
};
